import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import DataService from "@shared/services/DataService";
import { FormField } from "@shared/modules/utils";
import { I18n } from "@shared/modules/utils/LangUtil";
import EventService from "@shared/services/EventService";
import { InputAdornment } from "@mui/material";
import Keyboard from "react-simple-keyboard";
import "@app/stylesV2/modules/Login/ForgotPin/ResetPin.scss";

export const OTP_LENGTH = 6;
export const OTP_PREFIX_LENGTH = 4;
export const TOTAL_OTP_LENGTH = OTP_LENGTH + OTP_PREFIX_LENGTH;
const OTP_STATUSES = {
    "SMS":{"label":"your Mobile",'lbl':"motp"},
    "EMAIL":{"label":"your Email",'lbl':"eotp"},
    "WHATSAPP":{"label":"your WHATSAPP",'lbl':"wotp"},
    "EMAIL":{"label":"your Email",'lbl':"eotp"},
    "WOTP":{"label":"your WHATSAPP",'lbl':"wotp"},
    "Notp":{"label":"your Notp",'lbl':"otp"}
};
export const SUCCESS_STATUSES = ["VERIFY_SUCCESS", "SUCCESS", "USER_UPDATE_SUCCESS"];

class OtpPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            otpSent: false,
            disableSubmit: true,
            contactType: null,
            otpInputVal: "",
            preInputVal: "",
            totalSeconds:  60
        };
    }

    componentDidMount() {
        this.init();
        // EventService.publish("keyboard.hide");
    }

    init() {
        // this.otpInput.val(`${this.props.otpPrefix}-`);
        this.otpPrefix = this.props.otpPrefix;
        this.setState({
            otpSent: true,
            preInputVal: `${this.props.otpPrefix}-`
        });
        this.resetTimer();
        // this.startCountdown();
    }

    
    startCountdown = () => {
        this.timer = setInterval(() => {
        this.setState(prevState => {
            if (prevState.totalSeconds <= 1) {
            clearInterval(this.timer);
            return { totalSeconds: 0 };
            }
            return { totalSeconds: prevState.totalSeconds - 1 };
        });
        }, 1000);
    };

    resetTimer = () => {
        clearInterval(this.timer);
        this.setState(
        { totalSeconds:  60 },
        this.startCountdown
        );
    };

    formatTime = () => {
        const minutes = Math.floor(this.state.totalSeconds / 60);
        const seconds = this.state.totalSeconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    reset() {
        this.otpInput.clearError();
        this.otpInput.val("");
        // this.setState({
        //     otpInputVal: ``
        // });
    }

    handleOTPInput = newValue => {
        if (!this.otpPrefix) {
        } else {
            // this.otpInput.val(`${this.otpPrefix}-`);
            this.otpInput.clearError()
            this.setState({
                otpPrefix: `${this.otpPrefix}-`
            });
            if (newValue.length <= 6) {
                if (newValue.length === OTP_LENGTH) {
                    this.setState({ disableSubmit: false},()=>this.onClickNext());
                    // this.onClickNext()
                } else {
                    this.setState({ disableSubmit: true });
                }
                // this.otpInput.val(newValue);
                // this.setState({
                //     otpInputVal: newValue
                // });
            }
        }
    };

    handleKeyboardInput = newVal => {
        if (newVal) {
            let currValue = this.otpInput.val();
            let finalValue = currValue;
            if (newVal === "{backspace}") {
                finalValue = currValue.slice(0, -1);
            } else {
                finalValue = currValue + newVal;
            }
            this.handleOTPInput(finalValue);
        }
    };

    resendOTP = () => {
        let postMethodPromise;
        let { contactType } = this.state;
        contactType = contactType ? contactType : this.props.config.contactType;
        var reqBase64 = btoa(JSON.stringify({ contactType: contactType }));
        this.setState({ contactType: contactType });
        this.resetTimer();
        // this.startCountdown();
        if (this.props.postForm) {
            postMethodPromise = DataService.post(this.props.api, this.props.reqObj, {
                ...this.props.config,
                params: {
                    ...(this.props.config && this.props.config.params ? this.props.config.params : {}),
                    "x-app-authd-params": reqBase64
                },
                contactType: contactType,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                otpSuccessCallback: this.props.otpSuccessCallback
            });
        } else {
            postMethodPromise = DataService.post(
                this.props.api,
                {
                    ...(this.props.reqObj || {})
                },
                {
                    ...this.props.config,
                    params: {
                        ...(this.props.config && this.props.config.params ? this.props.config.params : {}),
                        "x-app-authd-params": reqBase64
                    },
                    contactType: contactType,
                    otpSuccessCallback: this.props.otpSuccessCallback
                }
            );
        }
        postMethodPromise.then(resp => {
            if (this.props.otpSentStatusKeys.indexOf(resp.statusKey) !== -1) {
                // this.otpInput.val(`${resp.meta.mOtpPrefix}-`);
                this.otpPrefix = resp.meta.mOtpPrefix || resp.meta.otpPrefix;
                this.otpInput.val("")
                this.setState({
                    otpSent: true,
                    preInputVal: `${this.otpPrefix}-`,
                    // otpInputVal: "",
                    disableSubmit: true
                });
            } else if (resp.statusKey != "CUSTOMER_MOBILE_EMPTY") {
                this.otpInput.setError(resp.errorMsg);
            }
        });
    };

    onClickNext = () => {
        this.setState({ loading: true });
        console.log("this.otpInput.isValid()",this.otpInput.isValid());
        if ([!this.otpPrefix || this.otpInput.isValid()].indexOf(false) !== -1){
            this.setState({ loading: false })
            return;
        } 

        // let mOtp = this.otpInput.val().split("-")[1];
        let mOtp = this.otpInput.val();
        let eOtp = ""
        let wOtp = ""
        if(this.props?.config?.contactType=="SMS" || this.props?.config?.contactType == "EMAIL" || this.props?.config?.contactType == "WHATSAPP" || this.props?.config?.contactType == "Notp"){
            mOtp = this.props?.config?.contactType=="SMS" || this.props?.config?.contactType=="Notp" ?this.otpInput.val():" ";
            eOtp = this.props?.config?.contactType=="EMAIL" ?this.otpInput.val():" ";
            wOtp = this.props?.config?.contactType=="WHATSAPP" ?this.otpInput.val():" ";
        }
        if (this.props.saveCallback)
            this.props
                .saveCallback({
                    id: this.props.meta.id,
                    mOtp,
                    eOtp,
                    wOtp,
                    otpSuccessCallback: this.props.otpSuccessCallback,
                    config: this.props.config,
                    contactType: this.state.contactType || this.props.config?.contactType
                })
                .then(resp => {
                    this.setState({ loading: false });
                    if (SUCCESS_STATUSES.indexOf(resp.statusKey) === -1) {
                        if (resp.messageKey === "INVALID_OTP") {
                            this.otpInput.setError(resp.errorMsg || resp.message);
                        }
                    }
                });
    };

    onClickCancel = () => {
        EventService.publish("fullscreenModal.hide");
    };

    render() {
        let conOtp=false
        let conType=""
        if(this.props?.config?.contactType=="SMS" || this.props?.config?.contactType == "EMAIL" || this.props?.config?.contactType == "WHATSAPP" || this.props?.config?.contactType == "Notp"){
            conOtp=true
            conType=this.props?.config?.contactType
        }

        const otpType = conOtp ? conType.toLocaleLowerCase() : "sms";

        return (
            <div className="ResetPin">
                <div className="image-container">
                    {(() => {
                        switch (otpType) {
                            case "email":
                                return (
                                    <img
                                        src={require("@app/stylesV2/images/PNG/email-icon.png")}
                                        alt="contact-type-icon"
                                    />
                                );

                            case "whatsapp":
                                return (
                                    <img
                                        src={require("@app/stylesV2/images/PNG/whatsapp-icon.png")}
                                        alt="contact-type-icon"
                                    />
                                );

                            case "sms":
                            default:
                                return (
                                    <img
                                        src={require("@app/stylesV2/images/PNG/sms-icon.png")}
                                        alt="contact-type-icon"
                                    />
                                );
                        }
                    })()}
                </div>
                {/* <span className="dialog__h2">
                    Please enter the OTP code you have <br />
                    received on{" "}
                    {this.props?.config?.contactType=="SMS" ? (
                        <span className="dialog__h3">{this.props.config.mobileNumber}</span>
                    ):(
                        `${OTP_STATUSES[conType]?.label}`
                    )

                }
                </span> */}
                <div className="detail-container">
                    <div className="contact_type">{I18n(`g.lbl.${conOtp ? OTP_STATUSES[conType]?.lbl : ""}`)}</div>
                    <div className="contact_text">{I18n(`g.msg.otp_${conType}`)}</div>
                </div>
                <div className="otp-box-conatiner">
                    <FormField
                        controlled={true}
                        type={"display"}
                        // defaultValue={this.state.preInputVal}
                        value={this.state.preInputVal}
                        containerClass={`civilidotp-prefix ${
                            this.state?.preInputVal?.length > 4 ? "civilidotp-prefix-large" : ""
                        }`}
                        ref={ref => (this.pwdPrefix = ref)}
                    />
                    <FormField
                        // controlled={true}
                        containerClass={"sm-otp"}
                        type={"otp2"}
                        // label={conOtp==false?I18n("g.lbl.motp"):I18n(`g.lbl.${OTP_STATUSES[conType].lbl}`)}
                        inputValidations={["validOTP"]}
                        ref={ref => (this.otpInput = ref)}
                        // value={this.otpInput.val()}
                        onChange={this.handleOTPInput}
                        disabled={!this.state.otpSent}
                        length={6}
                        sizeRange={[OTP_LENGTH, OTP_LENGTH]}
                        id="otp"
                        autoFocus={true}
                    />
                </div>
                {/* <div
                    className={`otp-button-text modal-sm ${this.state.loading ? "disabled" : ""}`}
                    style={{ fontSize: "27px" }}
                    {...(this.state.loading ? {} : { onClick: this.resendOTP })}
                >
                    {I18n("g.action.resendotp")}
                    <img className="search-adornment" src={require(`@app/styles/img/right-arrow.svg`)} alt="logo" />
                </div> */}
                <div className="otp-container-layout">
                    <div>
                        <span className="otp-expire-text">{I18n("g.lbl.otpExpire")} </span>
                        <span className="time">{this.formatTime()}</span>
                    </div>
                    <button className={`btn resend-otp-btn ${this.state.totalSeconds != 0 ? "disable" :""}`} onClick={this.resendOTP} disabled={this.state.totalSeconds != 0}>{I18n("g.action.resendotp1")}</button>
                </div>
                <br />
                {/* <div className="spacer-div2" style={{ width: "660px" }}>
                    <button
                        className={`primary-btn btn ${this.state.loading ? "disabled" : ""}`}
                        style={{ width: "300px", height: "123px", margin: 0 }}
                        onClick={this.onClickCancel}
                        {...(this.state.loading ? { disabled: true } : {})}
                    >
                        {I18n("g.action.cancel")}
                    </button>
                    <button
                        className={`success-btn btn ${
                            this.state.disableSubmit || this.state.loading ? "disabled" : ""
                        }`}
                        style={{ width: "300px", height: "123px", margin: 0 }}
                        onClick={this.onClickNext}
                        {...(this.state.disableSubmit || this.state.loading ? { disabled: true } : {})}
                    >
                        {I18n("g.action.next")}
                    </button>
                </div> */}
                <div className="forgot-pin-btn-container">
                    <button className="btn-secondary"onClick={this.onClickCancel}>{I18n("g.action.cancel")}</button>
                    <button className={`btn-primary  ${this.state.disableSubmit || this.state.loading ? "disabled" : ""}`}
                        onClick={this.onClickNext}
                        {...(this.state.disableSubmit || this.state.loading ? { disabled: true } : {})}
                        >{I18n("g.action.next")}</button>
                </div>
            </div>
        );
    }
}

export default withRouter(OtpPopup);
